/**
 * Match Sport — self-contained match-3 runtime hosted in a react-native-webview (native) /
 * srcDoc iframe (web). The document is the vendored Claude Design standalone bundle with the
 * Zporti host bridge added at extraction (scripts/extract-match-sport.mjs); the vendor file is
 * generated — never hand-edit it. Spec: specs/match-sport/spec.md.
 *
 * Fully offline: dc-runtime + React UMD + fonts + piece art are all inline — zero network I/O
 * (AC-4). Shipping as a template string keeps Metro's minifier away from the game code, so the
 * Blocky Striker fn.toString/minification freeze class of bug cannot occur.
 *
 * Bridge protocol (window.ReactNativeWebView.postMessage, window.parent fallback; JSON):
 *   web → RN:  { type:'ready' } | { type:'save', state } | { type:'load-error' }
 *              | { type:'level-result', level, win, stars, score }   (level 0 = daily challenge)
 *   RN → web:  window.__matchSportApplyStart({ savedState, insetTop, muted })
 *              window.__matchSportApplyAudio({ muted })
 *
 * The game keeps its own economy (in-game coins / boosters / upgrades) inside its
 * `zporti-match-v1` state; real Zporti coins are the host's business (useMatchSportGame).
 */

import { MATCH_SPORT_RUNTIME_HTML } from './matchSportRuntime.vendor';

export function buildMatchSportGameHtml(): string {
  return MATCH_SPORT_RUNTIME_HTML;
}
